<template>
  <div>
    <!--搜索-->
    <div>
      <van-search
          v-model="queryParams.name"
          show-action
          placeholder="请输入搜索关键词"
          @search="onSearch"
          style="padding:12px 12px"
          :clearable="false"
      >
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
    </div>

    <!-- 场馆分类 -->
    <div class="c-class">
      <van-tabs v-model="queryParams.venueClassId" title-active-color="#2C68E4" :border="false" @change="tabChange">
        <!--<van-tab title="全部" name="" v-if="venueClassOptions.length > 0"/>-->
        <van-tab v-for="(item, index) in venueClassOptions" :title="item.label" :name="item.value" :key="index"/>
      </van-tabs>
    </div>

    <!-- 会议室、教学楼显示筛选 -->
    <div class="search-two" v-show="['efa2e360142847c2aae5a2f30bc1ba0a', '1c19c767520449beb475a0276b3cc558'].includes(queryParams.venueClassId)">
      <div class="se-l">
        <span class="la">容纳人数：</span>
        <span class="la-de" @click="showPickerVa('0')">{{ propleColu[proIndex] }}<img src="@/assets/xy.png"></span>
      </div>
      <div class="se-r">
        <span class="la">面积：</span>
        <span class="la-de" @click="showPickerVa('1')">{{ mjCoclu[mjIndex] }}<img src="@/assets/xy.png"></span>
      </div>
    </div>

    <!-- 列表 -->
    <van-pull-refresh v-model="data.topLoading" @refresh="refresh()">
      <van-list
          v-model="data.bottomLoading"
          :finished="!data.hasMore"
          finished-text="没有更多了"
          @load="bottomRefresh()"
      >
        <div class="list-box" v-for="(item, index) in data.records" :key="index">
          <div class="list-top">
            <img :src="fileDisplayPrefix + (item.picUrls || '').split(',')[0]"/>
            <div class="list-r">
              <h2>
                <span>{{ item.name }}</span>
              </h2>
              <div class="taglist">
                <van-tag plain type="primary" v-for="(item, index) in (item.sportTypeValue || '').split(',')"
                         :key="index">
                  {{ item }}
                </van-tag>
                <i class="rs" v-if="item.capacity">{{ item.capacity + '人' }}</i>
                <i class="mj" v-if="item.areaCount">{{ item.areaCount + '㎡' }}</i>
              </div>
              <div class="adress"><img src="@/assets/adress.png">{{ item.address }}</div>
            </div>
          </div>
          <span class="y-but" @click="toDetail(item)">立即预约</span>
        </div>
      </van-list>
    </van-pull-refresh>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
          show-toolbar
          :columns="columns"
          @confirm="onConOkfirm"
          :default-index="pickerIndex"
          @cancel="showPicker = false"
      />
    </van-popup>

  </div>
</template>

<script>
import {FILE_DISPLAY_PREFIX} from '@/api/upload'
import {queryList, getVenueClassOptions, getSettingByKey} from '@/api/venue/venue'
import {handlePageData} from '@/utils/common'
import navBar from '@/components/NavBar'

export default {
  name: 'venue',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    navBar
  },
  data() {
    return {
      fileDisplayPrefix: FILE_DISPLAY_PREFIX,
      queryParams: {},
      classId: null,
      venueClassOptions: [],
      data: {
        records: [],
        current: 1,
        size: 10,
        total: 0,
        hasMore: true,
        loading: false,
        topLoading: false,
        bottomLoading: false
      },
      columns: ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'],
      //人数
      propleColu: [],
      //面积
      mjCoclu: [],
      //人数
      propleData: [],
      //面积
      mjCocData: [],
      //1面积
      type: '1',
      mjIndex: 0,
      proIndex: 0,
      showPicker: false,
      pickerIndex: 0
    }
  },
  computed: {
    venueClassId() {
      return this.$store.getters.venueClassId
    },
  },
  watch: {
    venueClassId(val) {
      this.queryParams.venueClassId = val
      this.$forceUpdate()
    }
  },
  created() {
    this.queryParams.venueClassId = this.venueClassId
    getSettingByKey({key: 'VENUE_SEARCH'}).then(res => {
      const data = JSON.parse(res.result)
      let com = ['全部']
      let propleColu = data.people.map(item => {
        return item.lable
      })
      this.propleColu = com.concat(propleColu)
      this.propleData = data.people
      com = ['全部']
      let mjCoclu = data.extent.map(item => {
        return item.lable
      })

      this.mjCoclu = com.concat(mjCoclu)
      this.mjCocData = data.extent
      this.refresh()
    })
  },
  methods: {
    onConOkfirm(value) {
      this.showPicker = false;
      if (this.type === '1') {
        this.mjIndex = this.mjCoclu.findIndex(item => item === value)
      } else {
        this.proIndex = this.propleColu.findIndex(item => item === value)
      }
      this.pickerIndex = value
      this.$nextTick(() => {
        this.data.records = []
        this.refresh()
      })
    },
    //选择下拉框
    showPickerVa(type) {
      this.type = type
      if (type === '1') {
        this.columns = this.mjCoclu
        this.pickerIndex = this.mjIndex
      } else {
        this.columns = this.propleColu
        this.pickerIndex = this.proIndex
      }
      this.showPicker = true
    },
    refresh() {
      getVenueClassOptions().then(res => {
        if (res.code === 10000) {
          this.venueClassOptions = res.result.filter(i => i.count > 0)
          this.reset()
          this.getList()
        }
      })
    },
    bottomRefresh() {
      if (this.data.current > 1 && this.data.hasMore)
        this.getList()
    },
    reset() {
      this.data.current = 1
      this.data.total = 0
      this.data.hasMore = true
    },
    getList() {
      if (this.data.loading) return
      this.data.loading = true
      this.queryParams.current = this.data.current
      this.queryParams.size = this.data.size

      if (this.mjIndex !== 0) {
        let nuVo = this.mjCocData[this.mjIndex-1]
        console.log('mjIndex', this.mjIndex, nuVo)
        this.queryParams.mjMin = nuVo.min
        this.queryParams.mjMax = nuVo.max
      }else {
        this.queryParams.mjMin = ''
        this.queryParams.mjMax = ''
      }
      if (this.proIndex !== 0) {
        let nuVo = this.propleData[this.proIndex-1]
        console.log('proIndex', this.proIndex, nuVo)
        this.queryParams.perMin = nuVo.min
        this.queryParams.perMax = nuVo.max
      }else {
        this.queryParams.perMin = ''
        this.queryParams.perMax =''
      }

      if (!this.venueClassId) {
        this.queryParams.venueClassId = (this.venueClassOptions[0] || {}).value
      }

      queryList(this.queryParams).then(res => {
        if (res.code === 10000) {
          setTimeout(() => {
            handlePageData(this.data, res.result)
          }, 100)
        }
      }).finally(() => {
        setTimeout(() => {
          this.data.loading = false
          this.data.topLoading = false
          this.data.bottomLoading = false
        }, 100)
      })
    },
    tabChange(e) {
      this.$store.commit('setVenueClassId', e)
      this.$nextTick(() => {
        // 清空筛选条件
        this.mjIndex = 0
        this.proIndex = 0
        this.data.records = []
        this.refresh()
      })
    },
    onSearch() {
      this.refresh()
    },
    toDetail(item) {
      this.$router.push({path: `/venue/detail?id=${item.id}`})
    }
  }
}
</script>
<style>
  .list-r h2{
    display: flex;
    align-items: center;
  }
  .list-r h2 span{
    display: flex;
    /*max-width:33vw;*/
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-line-clamp:1;
    -webkit-box-orient:vertical;
  }
  .list-r i{
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    padding: 2px 4px;
    border-radius: 3px;
    margin: 0 2px;
    color: #ffffff;
    font-weight: normal;
  }
  .list-r i.rs{
    background: #1CC700;
  }
  .list-r i.mj{
    background: deepskyblue;
  }
.search-two {
  background-color: #FFF;
  display: flex;
  font-size: 14px;
  height: 45px;
  display: flex;
  align-items: center;
  border-top: 1px solid #eef3f8;
  justify-content: space-between;
}
.search-two span{
  display: flex;
  align-items: center;
}
.se-l, .se-r{
  display: flex;
  flex: 1;
  height:26px;
  align-items: center;
  padding: 0 12px;
}
.se-l{
  border-right: 1px solid #eef3f8;
}
.search-two span{
  font-size: 14px;
}
.search-two .la {
  font-size: 14px;
}
.search-two .la-de{
  display: flex;
  flex: 1;
  justify-content: space-between;
}
.search-two .la-de img{
width:14px;
}
</style>

